import MasterWeekTemplates from "@/components/weekTemplate/MasterWeekTemplates.vue"
import WeekTemplateHeader from "@/components/weekTemplate/WeekTemplateHeader.vue"
import WeekTemplateActions from "@/components/weekTemplate/WeekTemplateActions.vue"
import WeekTemplateMenu from "@/components/weekTemplate/WeekTemplateMenu.vue"
import WeekTemplateSourcePanel from "@/components/weekTemplate/WeekTemplateSourcePanel.vue"
import DetailsWeekMaster from "@/components/weekTemplate/Details_Master.vue";
import WeekTemplateDetails from "@/components/weekTemplate/WeekTemplateDetails";
import MenuList from "@/components/weekTemplate/MenuList";

export default {
    path: '/:stationUid/week-templates',
    components: {
        default: MasterWeekTemplates,
    }, children: [

        {
            name: "WeekTemplatesHome", path: "/",
            components: {
                default: WeekTemplateDetails,
                subPageHeader: WeekTemplateHeader,
                pageActions: WeekTemplateActions,
                rightPanel: WeekTemplateSourcePanel,
                pageSubMenu: WeekTemplateMenu,
            },

        }


    ]
};
